import type { ReviewCellRef } from 'store/useReviewStore';

// SCAL-8976: the cap-table grid stamps each cell DOM node (via ContentColumns'
// attributesRenderer) with `data-column-id={columnId}` and `data-alias={alias}`.
// A review card carries `{ securityId (= Number(columnId)), fieldAlias (= alias) }`,
// so a cell is addressable by matching both attributes. The values go inside a
// double-quoted attribute-selector string, where only `"` and `\` need escaping
// (NOT CSS.escape, which is for bare identifiers and would mangle leading digits).
const escapeAttr = (value: string): string => value.replace(/["\\]/g, '\\$&');

/**
 * Build the CSS selector that targets the grid cell for a review ref. Matches both
 * the numeric `securityId` and its string form (data-column-id is rendered from the
 * raw columnId, which may be a string), so `5` and `"5"` both resolve.
 */
export const reviewCellSelector = ({ securityId, fieldAlias }: ReviewCellRef): string =>
  `td[data-column-id="${escapeAttr(String(securityId))}"][data-alias="${escapeAttr(fieldAlias)}"]`;
